<script setup lang="ts">
import { ref, onMounted } from 'vue'

import BatchTypeHeader from '@/components/features/batches/tab-content/BatchTypeHeader.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import { RouterLink } from 'vue-router'
import { Icon } from '@iconify/vue'
import type { Supplier } from '@/types/supplier-types'
import { getSupplierList } from '@/api/suppliers'
import {getSupplier} from '@/constants/suppliers'
import {formatedDate} from '@/constants'
import {getBatchById} from "@/api/batches";
import { getFinishedProduct } from '@/constants/productSpecification'
import type { Product } from '@/types/product-types'
import { getProductList } from '@/api/products'

const props = defineProps<{
  batchList: any
}>()

const products = ref<Product[]>([])

const batchNumbers = ref<Map<string, string>>(new Map())

const loadBatchNumber = async (previousBatchId: string) => {
  if (!batchNumbers.value.has(previousBatchId)) {
    const batch = await getBatchById(previousBatchId)
    batchNumbers.value.set(previousBatchId, batch.batchNumber?.toString() || '-')
  }
}

onMounted(async () => {
  products.value = await getProductList()

  for (const batch of props.batchList) {
    if (batch.previousBatchId) {
      await loadBatchNumber(batch.previousBatchId)
    }
  }
})
</script>

<template>
  <BatchTypeHeader
    title="Available"
    description="Find all batches available to be shipped out here."
    :display-add-button="true"
  />

  <DataTable :value="batchList" class="px-0">
    <Column field="previousBatchId" header="Batch Number">
      <template #body="slotProps">
        <RouterLink
            :to="`/batches/available-batches-details/${slotProps.data.id}`"
            class="font-medium text-neutral-800 block hover:underline"
        >
          {{ slotProps.data.batchNumber }}
        </RouterLink>
      </template>
    </Column>
    <Column field="finishingQualityId" header="Batch Quality">
      <template #body="slotProps">
        <RouterLink
          :to="`/productSpecification/${slotProps.data.finishingQualityId}`"
          class="font-medium text-neutral-800 block hover:underline"
        >
          {{ getFinishedProduct(slotProps.data.finishingQualityId, products) }}
        </RouterLink>
      </template>
    </Column>
    <Column field="returnedRolls.length" header="Number of Rolls" />
    <Column field="dateReturned" header="Date Ready" >
      <template #body="slotProps">
        <span>{{ formatedDate(slotProps.data.dateReturned) }}</span>
      </template>
    </Column>
    <Column field="action">
      <template #body="slotProps">
        <RouterLink
          :to="`/batches/available-batches-details/${slotProps.data.id}`"
          class="flex items-center gap-x-2 group hover:text-primary-default"
        >
          <span>More details</span>
          <Icon
            icon="material-symbols:more-up"
            class="text-2xl group-hover:translate-x-2 transition-transform text-primary-500"
          />
        </RouterLink>
      </template>
    </Column>
  </DataTable>
</template>